
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/najczesciej-zadawane-pytania-faq",
      function () {
        return require("private-next-pages/najczesciej-zadawane-pytania-faq/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/najczesciej-zadawane-pytania-faq"])
      });
    }
  